import { useState } from 'react';
import LeaveReviewForm from './LeaveReviewForm';

const testimonials = [
  {
    stars: 5,
    industry: 'Hair & Beauty',
    icon: 'ri-scissors-2-line',
    quote: 'No-shows dropped by nearly half in the first month',
    body: 'I had clients just not showing up with no warning. Now they get reminders automatically and can confirm or reschedule from their phone. It has made such a difference to how full my week stays.',
    name: 'Emma R.',
    role: 'Salon Owner',
  },
  {
    stars: 5,
    industry: 'Builders & Trades',
    icon: 'ri-hammer-line',
    quote: 'I was losing jobs just because I was slow to reply',
    body: 'Homeowners move fast. If you do not reply within an hour they call someone else. Now every enquiry gets an instant response even when I am on a job. Picked up three new contracts in the first two weeks.',
    name: 'Marcus D.',
    role: 'Builder',
  },
  {
    stars: 5,
    industry: 'Dental & Clinics',
    icon: 'ri-heart-pulse-line',
    quote: 'New patients are booking themselves in without any back and forth',
    body: 'We used to have a pile of missed calls every morning. Now new patient enquiries come in and get handled instantly. The appointment is booked, the intake form is sent, and I find out about it after the fact.',
    name: 'Hannah W.',
    role: 'Clinic Manager',
  },
  {
    stars: 5,
    industry: 'Fitness & Wellness',
    icon: 'ri-run-line',
    quote: 'Trial members are converting at a much higher rate now',
    body: 'Before, people would come in for a free session and then go quiet. Now they get a follow-up the same day, an offer a few days later, and most of them end up joining. The difference is night and day.',
    name: 'Tom B.',
    role: 'Personal Trainer',
  },
  {
    stars: 5,
    industry: 'Physio & Therapy',
    icon: 'ri-stethoscope-line',
    quote: 'Admin that used to take two hours now just handles itself',
    body: 'Intake forms, appointment reminders, follow-up messages after sessions. All of it runs automatically. I spend that time with patients instead of on my phone or laptop. Genuinely game changing for a solo practice.',
    name: 'Claire H.',
    role: 'Physiotherapist',
  },
  {
    stars: 5,
    industry: 'Home Services',
    icon: 'ri-home-heart-line',
    quote: 'Repeat bookings just happen without me chasing anyone',
    body: 'Clients used to drift away because I never had time to follow up. Now the system sends a reminder at the right time and they rebook. My schedule stays full without me lifting a finger.',
    name: 'Diane F.',
    role: 'Cleaning Business Owner',
  },
  {
    stars: 5,
    industry: 'Hair & Beauty',
    icon: 'ri-scissors-2-line',
    quote: 'Enquiries at 11pm used to just disappear',
    body: 'Most of my clients message in the evenings when I am done for the day. I was losing bookings every night without knowing it. Now every message gets a response and the booking gets made. My diary has never been this full.',
    name: 'Jade T.',
    role: 'Beauty Therapist',
  },
  {
    stars: 5,
    industry: 'Builders & Trades',
    icon: 'ri-hammer-line',
    quote: 'Quote follow-ups recovered jobs I had written off',
    body: 'I sent quotes and heard nothing back so I assumed they went elsewhere. Turns out people just get busy and forget. The automated follow-ups brought three jobs back in the first month that I had given up on.',
    name: 'Ryan K.',
    role: 'Plumber',
  },
  {
    stars: 5,
    industry: 'Dental & Clinics',
    icon: 'ri-heart-pulse-line',
    quote: 'My receptionist is actually free to help patients now',
    body: 'She was spending the first two hours every day just returning calls and sorting bookings. All of that is handled overnight now. She actually has time to focus on the people sitting in front of her.',
    name: 'Dr. Chris A.',
    role: 'Dental Practice Owner',
  },
  {
    stars: 5,
    industry: 'Fitness & Wellness',
    icon: 'ri-run-line',
    quote: 'Members who go quiet now come back on their own',
    body: 'We lose members to life getting in the way. The re-engagement sequences catch them at the right moment with the right message. We have had people come back after three months saying they just needed a nudge.',
    name: 'Steph N.',
    role: 'Gym Owner',
  },
  {
    stars: 5,
    industry: 'Home Services',
    icon: 'ri-home-heart-line',
    quote: 'Google reviews started piling up after every job',
    body: 'I knew I should be asking for reviews but always forgot or felt awkward about it. Now a message goes out automatically after every job. My Google rating went from 4.1 to 4.8 in about six weeks.',
    name: 'Joe M.',
    role: 'Landscaper',
  },
  {
    stars: 5,
    industry: 'Physio & Therapy',
    icon: 'ri-stethoscope-line',
    quote: 'Clients actually show up prepared now',
    body: 'Pre-session intake questions go out automatically so by the time they arrive I already know their history. It saves time in the session and they feel like the service is more professional. Clients have mentioned it unprompted.',
    name: 'Dr. Sam L.',
    role: 'Sports Therapist',
  },
];

const CARD_WIDTH = 380;
const GAP = 24;
const SINGLE_TRACK_PX = testimonials.length * (CARD_WIDTH + GAP);

const TestimonialsSection = () => {
  const [paused, setPaused] = useState(false);
  const doubled = [...testimonials, ...testimonials];

  return (
    <section className="bg-ea-navy py-24 overflow-hidden">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-ea-blue/10 border border-ea-blue/30 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-ea-blue"></span>
              <span className="text-ea-blue text-xs font-medium uppercase tracking-wider">Client Success</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-3">
              Businesses Growing with{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-ea-blue to-ea-blue-electric">
                AI Automation
              </span>
            </h2>
            <p className="text-ea-gray text-base max-w-xl">
              Real results from real businesses across every industry we work with.
            </p>
          </div>
          <p className="text-ea-gray text-sm flex items-center gap-2 flex-shrink-0">
            <i className="ri-cursor-line text-ea-blue"></i>
            Hover to pause
          </p>
        </div>
      </div>

      {/* Infinite scroll track */}
      <div
        className="w-full overflow-hidden"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        style={{ cursor: 'default' }}
      >
        <div
          className="flex"
          style={{
            gap: `${GAP}px`,
            width: `${SINGLE_TRACK_PX * 2}px`,
            animation: `scrollReviews 70s linear infinite`,
            animationPlayState: paused ? 'paused' : 'running',
          }}
        >
          {doubled.map((t, idx) => (
            <div
              key={idx}
              className="flex-shrink-0 bg-ea-dark-card border border-ea-dark-border hover:border-ea-blue/40 rounded-xl p-7 flex flex-col transition-colors duration-300"
              style={{ width: `${CARD_WIDTH}px` }}
            >
              {/* Industry tag + stars */}
              <div className="flex items-center justify-between mb-5">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-ea-blue/10 border border-ea-blue/20">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className={`${t.icon} text-ea-blue`} style={{ fontSize: '11px' }}></i>
                  </div>
                  <span className="text-ea-blue text-xs font-medium">{t.industry}</span>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: t.stars }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-ea-blue" style={{ fontSize: '12px' }}></i>
                  ))}
                </div>
              </div>

              {/* Quote headline */}
              <h4 className="text-white font-bold text-base mb-3 leading-snug">
                &ldquo;{t.quote}&rdquo;
              </h4>

              {/* Body */}
              <p className="text-ea-gray text-sm leading-relaxed flex-1">{t.body}</p>

              {/* Author */}
              <div className="mt-6 pt-5 border-t border-ea-dark-border">
                <p className="text-white font-semibold text-sm">{t.name}</p>
                <p className="text-ea-gray text-xs mt-0.5">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Leave a review */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mt-20">
        <LeaveReviewForm />
      </div>

      <style>{`
        @keyframes scrollReviews {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-${SINGLE_TRACK_PX}px); }
        }
      `}</style>
    </section>
  );
};

export default TestimonialsSection;
